/*
   Define a list of available report topics.
 */
export enum FinancialReportTopic {
    AnnualReports = 'Annual Reports',
    InterimReport = 'Interim report',
}
